const VERIF = {
  verified_shade: { label: "Ingredients documented", cls: "bg-[#EAF3ED] text-[#2E6B4F] border-[#cfe3d6]" },
  partial: { label: "Ingredients partially documented", cls: "bg-[#FAF2E6] text-[#9C6218] border-[#efdcbc]" },
  unverified: { label: "Ingredients not yet verified", cls: "bg-[#F6F1EA] text-[#6E5549] border-[#E6DBCF]" },
  name_only: { label: "Not yet verified · name only", cls: "bg-[#F9ECEC] text-[#8C2A2A] border-[#ecd0d0]" },
};

const CONF = {
  high: "bg-[#2C1810] text-[#FDFBF7]",
  moderate: "bg-[#C5A059] text-[#2C1810]",
  limited: "bg-[#E8BDB5] text-[#2C1810]",
};

export const READINESS = {
  proceed: { label: "Proceed with professional assessment", short: "Proceed", cls: "bg-[#EAF3ED] text-[#2E6B4F] border-[#2E6B4F]/30" },
  more_info: { label: "More information needed", short: "More info", cls: "bg-[#FAF2E6] text-[#9C6218] border-[#9C6218]/30" },
  postpone_refer: { label: "Postpone or refer", short: "Postpone / refer", cls: "bg-[#F9ECEC] text-[#8C2A2A] border-[#8C2A2A]/30" },
};

const pill = "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em]";

export const VerificationBadge = ({ status, testId }) => {
  const v = VERIF[status] || VERIF.unverified;
  return <span data-testid={testId} className={`${pill} ${v.cls}`}>{v.label}</span>;
};

export const ConfidenceBadge = ({ level, testId }) => (
  <span data-testid={testId} className={`${pill} border-transparent ${CONF[level] || CONF.limited}`}>
    {level || "limited"} confidence
  </span>
);

export const ReadinessBadge = ({ status, testId }) => {
  const r = READINESS[status];
  if (!r) return null;
  return <span data-testid={testId} className={`${pill} ${r.cls}`}>{r.short}</span>;
};

export const CiChips = ({ ci = [], testId }) =>
  ci.length ? (
    <div className="flex flex-wrap gap-1" data-testid={testId}>
      {ci.map((c) => (
        <span
          key={c}
          className={`font-mono-ig rounded-md border px-1.5 py-0.5 text-[10px] ${
            c === "77266" ? "border-[#2C1810] bg-[#2C1810] text-[#FDFBF7]" : "border-[#E6DBCF] bg-[#FDFBF7] text-[#3D2317]"
          }`}
          title={c === "77266" ? "Carbon black — tracked separately" : undefined}
        >
          CI {c}
        </span>
      ))}
    </div>
  ) : (
    <span data-testid={testId} className="font-mono-ig text-[10px] uppercase tracking-wider text-[#9C6218]">
      CI not verified
    </span>
  );
